import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import { auth } from "../firebase-config"; // shared singleton
import { onAuthStateChanged } from "firebase/auth";

const AuthContext = createContext({ user: null, loading: true, initializing: true });

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);  // alias: initializing
  const unsubRef = useRef(null);

  useEffect(() => {
    // Important: do NOT call setPersistence here.
    // SessionProvider already set the desired persistence based on route.

    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });

    // Store for strict-mode double mount safety & proper cleanup
    unsubRef.current = unsubscribe;
    return () => {
      if (unsubRef.current) {
        try { unsubRef.current(); } catch {}
        unsubRef.current = null;
      }
    };
  }, []);

  const value = {
    user,
    loading,
    initializing: loading, // keep old callers working
  };

  // Only render children after the first auth resolution
  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}